import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { TreeView, TreeViewSource } from '@shared/gui/models/tree-view.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TreeViewService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/treeview';

  public getTreeViews(): Observable<Array<TreeViewSource>> {
    return this.http.get<Array<TreeViewSource>>(this.baseUrl + '/tree-views');
  }

  public getTreeViewData(treeViewIds: Array<string>): Observable<{ [key: string]: TreeView }> {
    // TODO add some cache to boost tree views
    return this.http.post<{ [key: string]: TreeView }>(this.baseUrl + '/tree-view-data', treeViewIds);
  }
}
